import type {Level} from 'shells/status-badge/status-badge';

export const POLL_INTERVAL_MS = 3000; // 3 seconds
export const VERIFICATION_TIMEOUT_MS = 90000; // 90 seconds

export const VerificationState = {
    IDLE: 'idle',
    VERIFYING: 'verifying',
    VERIFIED: 'verified',
    FAILED: 'failed',
} as const;
export type VerificationState = (typeof VerificationState)[keyof typeof VerificationState];

export const STATUS_BADGE_PROPS: Record<VerificationState, {level: Level; text: string}> = {
    [VerificationState.IDLE]: {level: 'info--grey', text: 'Not verified'},
    [VerificationState.VERIFIED]: {level: 'success', text: 'Verified'},
    [VerificationState.VERIFYING]: {level: 'info', text: 'Verifying…'},
    [VerificationState.FAILED]: {level: 'alert', text: 'Failed'},
};
